import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { APIService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class VacanciesService extends APIService {
  active_vacancies: any = {
    data: null,
    skip: 0,
    limit: 1000
  };
  constructor(http: HttpClient, router: Router) {
    super(http);
    this.endPoint = "vacancies";
  }

  getAll(skip = null, limit = null, searchParams = null) {
    var pagination = "?";
    if (skip != null && limit != null)
      pagination += `skip=${skip}&limit=${limit}`;

    let arrayOfSearch = [];
    if (searchParams != null)
      for (const [key, value] of Object.entries(searchParams)) {
        arrayOfSearch.push(key + "=" + value);
      }
    return this.http.get(
      this.url + pagination + `&` + arrayOfSearch,
      this.httpOptions
    );
  }

  async getAllActive(skip = null, limit = null) {
    if (
      !this.active_vacancies.data ||
      this.active_vacancies.skip != skip ||
      this.active_vacancies.limit != limit
    ) {
      var pagination = "?";
      if (skip != null && limit != null)
        pagination += `skip=${skip}&limit=${limit}`;
      await this.http
        .get(
          this.url + "/active" + pagination + `&is_active=true`,
          this.httpOptions
        )
        .toPromise()
        .then((res) => this.active_vacancies.data = res["data"]);
      this.active_vacancies.skip = skip;
      this.active_vacancies.limit = limit;
    }
    return this.active_vacancies.data;
  }

  get(id) {
    return this.http.get(this.url + `/${id}`, this.httpOptions);
  }

  add(record) {
    return this.http.post(this.url, record, this.httpOptions);
  }

  update(record, id) {
    return this.http.put(this.url + `/${id}`, record, this.httpOptions);
  }

  delete(id) {
    return this.http.delete(this.url + `/${id}`, this.httpOptions);
  }

  getByJobID(job_id) {
    return this.http.get(this.url + `/job/${job_id}`, this.httpOptions);
  }
}
